import { render, staticRenderFns } from "./Firm.vue?vue&type=template&id=6a56b1f0&"
import script from "./Firm.vue?vue&type=script&lang=js&"
export * from "./Firm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports